import { getApps, initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
};
const missingFirebaseConfig = [
    ["VUE_APP_FIREBASE_API_KEY", firebaseConfig.apiKey],
    ["VUE_APP_FIREBASE_AUTH_DOMAIN", firebaseConfig.authDomain],
    ["VUE_APP_FIREBASE_PROJECT_ID", firebaseConfig.projectId],
    ["VUE_APP_FIREBASE_APP_ID", firebaseConfig.appId],
]
    .filter(([, value]) => !value)
    .map(([key]) => key);
if (missingFirebaseConfig.length) {
    throw new Error(`Missing required Firebase configuration: ${missingFirebaseConfig.join(", ")}`);
}
const app = getApps()[0] ?? initializeApp(firebaseConfig);
export const auth = getAuth(app);
const authEmulatorUrl = process.env.VUE_APP_FIREBASE_AUTH_EMULATOR_URL;
if (authEmulatorUrl) {
    connectAuthEmulator(auth, authEmulatorUrl);
}
